// Schema.org structured data for SEO

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Aturno",
  "alternateName": "Aturno - Sistema de Turnos Online",
  "url": "https://aturno.app",
  "logo": "https://aturno.app/logo-aturno.png",
  "description": "Software de gestión de turnos online para negocios. Automatizá las reservas de tu negocio y ahorrá +20 horas por semana.",
  "foundingDate": "2024",
  "founders": [
    {
      "@type": "Person",
      "name": "Aturno Team"
    }
  ],
  "address": {
    "@type": "PostalAddress",
    "addressCountry": "AR",
    "addressRegion": "Buenos Aires",
    "addressLocality": "CABA"
  },
  "contactPoint": {
    "@type": "ContactPoint",
    "contactType": "customer service",
    "email": "soporte@aturno.app",
    "availableLanguage": ["Spanish"]
  },
  "sameAs": [
    "https://www.linkedin.com/company/aturno",
    "https://www.instagram.com/aturno",
    "https://twitter.com/aturno_app"
  ]
};

export const softwareApplicationSchema = {
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  "name": "Aturno - Sistema de Turnos Online",
  "description": "Software de gestión de turnos que permite a tus clientes reservar online 24/7. Ideal para peluquerías, barberías, consultorios, spa y cualquier negocio que necesite organizar turnos.",
  "url": "https://aturno.app",
  "downloadUrl": "https://aturno.app/auth/register",
  "screenshot": "https://aturno.app/screenshot.png",
  "applicationCategory": "BusinessApplication",
  "applicationSubCategory": "Appointment Scheduling Software",
  "operatingSystem": "Web, iOS, Android",
  "offers": {
    "@type": "Offer",
    "price": "0",
    "priceCurrency": "ARS",
    "description": "Prueba gratis disponible - No requiere tarjeta de crédito"
  },
  "author": {
    "@type": "Organization",
    "name": "Aturno"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "1000",
    "bestRating": "5",
    "worstRating": "1"
  },
  "featureList": [
    "Reservas online 24/7 sin atender el teléfono",
    "Notificaciones automáticas por email (WhatsApp próximamente)",
    "Dashboard para gestionar tu negocio",
    "Integración con Google Calendar",
    "Gestión de múltiples empleados",
    "Configuración de servicios y precios",
    "Reportes y estadísticas de tu negocio",
    "Pagos online con MercadoPago"
  ]
};

export const webSiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "Aturno",
  "alternateName": "Aturno - Gestión de Turnos",
  "url": "https://aturno.app",
  "description": "Plataforma de gestión de turnos para empresas",
  "publisher": {
    "@type": "Organization",
    "name": "Aturno"
  },
  "potentialAction": {
    "@type": "SearchAction",
    "target": {
      "@type": "EntryPoint",
      "urlTemplate": "https://aturno.app/search?q={search_term_string}"
    },
    "query-input": "required name=search_term_string"
  }
};

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": items.map((item, index) => ({
    "@type": "ListItem",
    "position": index + 1,
    "name": item.name,
    "item": item.url
  }))
});

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map(faq => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer
    }
  }))
});

export const serviceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Sistema de Gestión de Turnos",
  "description": "Servicio completo de gestión de turnos y reservas online para empresas",
  "provider": {
    "@type": "Organization",
    "name": "Aturno"
  },
  "areaServed": {
    "@type": "Country",
    "name": "Argentina"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Planes de Aturno",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Plan Gratuito"
        },
        "price": "0",
        "priceCurrency": "ARS"
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Plan Profesional"
        },
        "price": "2500",
        "priceCurrency": "ARS"
      }
    ]
  }
};